import { render, staticRenderFns } from "./ReplacementsMercList.vue?vue&type=template&id=507a237e&scoped=true&"
import script from "./ReplacementsMercList.vue?vue&type=script&lang=js&"
export * from "./ReplacementsMercList.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementsMercList.vue?vue&type=style&index=0&id=507a237e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a237e",
  null
  
)

export default component.exports